import * as ACTION_TYPES from './Types';

const initialState = {
  manufacturers: {},
  message: '',
  error: null,
}

export const manufacturerReducer = (state = initialState, action) => {
  switch (action.type) {



    case ACTION_TYPES.GETMANUFACTURER_SUCCESS:
      return {
        ...state,
        manufacturers: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.GETMANUFACTURER_ERROR:

      return {
        ...state,
        message: action.payload.message,
      }

    case ACTION_TYPES.CHANGEACTION_SUCCESS:
    case ACTION_TYPES.APPROVAL_SUCCESS:
      return {
        ...state,
        manufacturers: action.payload.data,
        message: action.payload.message,
      }


    case ACTION_TYPES.CHANGEACTION_ERROR:
    case ACTION_TYPES.APPROVAL_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }

    default:
      return state;
  }
}
